import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";
// import i18n (needs to be bundled ;))
import "./i18n";

const startApp = () => {
	if (process.env.REACT_APP_SENTRY)
		Sentry.init({
			dsn: process.env.REACT_APP_SENTRY,
			integrations: [new Sentry.BrowserTracing()],
			tracesSampleRate: process.env.REACT_APP_SENTRY_RATE || 1.0,
		});

	ReactDOM.render(
		<Suspense fallback="loading...">
			<App />
		</Suspense>,
		document.getElementById("root")
	);
};

if (!window.cordova) {
	startApp();
} else {
	document.addEventListener("deviceready", startApp, false);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
